<template>
  <div id="search">
    <SearchEngine ></SearchEngine>
  </div>
</template>

<script>
import SearchEngine from "@/components/SearchEngine.vue";
import Api from "@/services/Api.service.js";

export default {
  name: "search",
  props: {
    loginKey: {
      type: String,
      default: null,
    },
    points: {
        type: String,
        default: null
    },
    firstName: {
      type: String,
      default: null,
    },
    surname: {
      type: String,
      default: null,
    },
    transactionId: {
      type: String,
      default: null,
    },
    msisdn: {
      type: String,
      default: null,
    },
    tier: {
      type: String,
      default: null,
    },
  },
  methods: {},
  mounted() {
    this.$store.commit("checkLoginKey", this.loginKey);
    this.$store.commit("setSelectedCar", {});
    // if (this.points) {
    //   this.$store.commit('setPoints', this.points);
    // }
  },
  components: {
    SearchEngine,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/settings.scss";

#search {
  margin: 10% 8px;
}

@media (min-width: 781px) {
  #search {
    min-width: 550px;
    margin: auto;
    margin: $standard-margin * 4 8px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: auto;
    grid-auto-rows: minmax(10px, auto);
    grid-column-gap: $standard-margin * 3;
    grid-row-gap: $standard-margin * 3;
    grid-template-areas: "search search search";
  }
  .search_engine {
    grid-area: search;
    width: 100%;
  }
}
</style>
